{
  "fieldia": "0.13",
  "id": "customer-feedback",
  "title": "How did we do?",
  "description": "Two minutes of your time. Every answer is read, and it changes what we do next.",
  "data": {
    "kind": "responses"
  },
  "maxWidth": "medium",
  "look": {
    "theme": "google-forms"
  },
  "fields": {
    "branch": {
      "type": "selection",
      "label": "Which branch did you visit?",
      "required": true,
      "options": [
        {
          "value": "downtown",
          "label": "Downtown"
        },
        {
          "value": "riverside",
          "label": "Riverside"
        },
        {
          "value": "hillcrest",
          "label": "Hillcrest"
        }
      ]
    },
    "overall": {
      "type": "integer",
      "label": "How was your visit to {branch|us}?",
      "required": true,
      "min": 1,
      "max": 5
    },
    "recommend": {
      "type": "integer",
      "label": "How likely are you to recommend us to a friend?",
      "required": true,
      "min": 0,
      "max": 10
    },
    "liked": {
      "type": "selection",
      "label": "What went well?",
      "multiple": true,
      "options": [
        {
          "value": "speed",
          "label": "It was quick"
        },
        {
          "value": "staff",
          "label": "Friendly people"
        },
        {
          "value": "quality",
          "label": "Quality"
        },
        {
          "value": "price",
          "label": "Fair price"
        },
        {
          "value": "easy",
          "label": "Easy to use"
        }
      ]
    },
    "better": {
      "type": "text",
      "label": "What could {branch|we} do better?",
      "size": 2000
    },
    "follow_up": {
      "type": "boolean",
      "label": "You may contact me about my answers"
    },
    "email": {
      "type": "char",
      "label": "Email",
      "pattern": "^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$"
    }
  },
  "layout": {
    "type": "sections",
    "id": "feedback",
    "children": [
      {
        "type": "section",
        "id": "questions",
        "title": "Your experience",
        "columns": 1,
        "children": [
          {
            "type": "field",
            "id": "f-branch",
            "field": "branch",
            "widget": "radio"
          },
          {
            "type": "field",
            "id": "f-overall",
            "field": "overall",
            "widget": "rating"
          },
          {
            "type": "field",
            "id": "f-recommend",
            "field": "recommend",
            "widget": "scale",
            "options": {
              "startLabel": "Not likely",
              "endLabel": "Very likely"
            }
          },
          {
            "type": "field",
            "id": "f-liked",
            "field": "liked",
            "widget": "checkboxes"
          },
          {
            "type": "field",
            "id": "f-better",
            "field": "better"
          },
          {
            "type": "field",
            "id": "f-follow",
            "field": "follow_up",
            "widget": "toggle"
          },
          {
            "type": "field",
            "id": "f-email",
            "field": "email",
            "widget": "email",
            "invisible": "not follow_up",
            "required": "follow_up"
          }
        ]
      }
    ]
  },
  "endings": [
    {
      "when": "overall <= 2 and follow_up",
      "title": "We are sorry, and thank you for telling us",
      "text": "The manager at {branch} reads every answer, and will write to you at {email} within a day.",
      "again": false
    },
    {
      "when": "overall <= 2",
      "title": "We are sorry, and thank you for telling us",
      "text": "The team at {branch} reads every answer, and it changes what we do next.",
      "again": false
    },
    {
      "title": "Thank you!",
      "text": "We are glad you came to {branch}. See you again soon."
    }
  ]
}
